export default __webpack_public_path__ + "static/media/about-us-intro.312cdc69.mp4";